import { useState } from 'react';
import { InputProps, useInput, useRecordContext } from 'react-admin';
import _ from 'lodash';
import { SpeakersField } from '../fields';
import { SpeakerParserDialog } from './SpeakerParserDialog';

export const SpeakerInput = (props: InputProps<any>) => {
  const record = useRecordContext();
  const [spkrsId, setSpkrsId] = useState<string[]>(record?.speakersId || []);
  const {
    field: { onChange },
  } = useInput(props);

  const updateSpeakers = (spks: string[]) => {
    console.log('-- SpeakerInput.updateSpeakers ', spks);
    const spksUpd = _.uniq(spkrsId.concat(spks) || []);
    setSpkrsId(spksUpd);
    onChange(spksUpd);
  };
  const onUpdateSpeakers = (evt: { target: { value: string[] } }) => {
    updateSpeakers(evt.target.value);
  };

  return (
    <>
      <SpeakersField
        options={{
          value: spkrsId,
          onChange: onUpdateSpeakers,
        }}
        value={spkrsId}
      />
      <SpeakerParserDialog source="speakersId" onChange={updateSpeakers} />
    </>
  );
};
